import { render, staticRenderFns } from "./GuardianChildrenList.vue?vue&type=template&id=228f47f8&"
import script from "./GuardianChildrenList.vue?vue&type=script&lang=js&"
export * from "./GuardianChildrenList.vue?vue&type=script&lang=js&"
import style0 from "./GuardianChildrenList.vue?vue&type=style&index=0&id=228f47f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports